<template>
  <div class="flex" :class="message.fromUser ? 'flex-x-start' : 'flex-x-end'">
    <div class="p-24 bubble widget" :class="message.fromUser ? 'from-user' : 'to-user'">
      <header class="text-muted flex-x-between flex-nowrap mb-12">
        <span class="mr-12 text-bold">{{ message.fromUser ? 'Вы' : 'Специалист техподдержки' }}</span>
        <span>{{ formatDate(message.date) }}</span>
      </header>
      <p v-html="message.content" />
      <p>
        <a
          v-for="file in message.files"
          :key="file.link"
          class="link"
          :href="file.link">
          {{ file.name }}
        </a>
      </p>
    </div>
  </div>
</template>

<script>
  import { formatDate } from '@/utils'

  export default {
    props: {
      message: {
        type: Object,
        required: true
      }
    },

    methods: {
      formatDate
    }
  }
</script>

<style lang="scss" scoped>
.bubble {
  position: relative;
  width: 100%;
  overflow: visible;

  &::before {
    content: '';
    bottom: -20px;
    position: absolute;
    width: 20px;
    height: 20px;
    border-left: 10px solid #fff;
    border-top: 10px solid #fff;
    border-right: 10px solid transparent;
    border-bottom: 10px solid transparent;
  }
}

.bubble.to-user::before {
  transform: scaleX(-1);
  right: 24px;
}

</style>